import React from 'react';
import RecoverableImage from '../images/RecoverableImage';
import Link from './BrowseLink';
import AlbumContentTitle from '../../components/content/AlbumContentTitle';
import AppAuthor from '../../app-ui/AppAuthor';
import baseline, { appTextStyle } from '../../app-ui/baseline';
import { useAppUi } from '../../app-ui/AppUiScope';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { reviewPath, reviewAlbumPath } from './contracts';
export function BrowseRating({ value, accent = false }) {
  const { locale } = useWebLocale();
  const appUi = useAppUi();
  const score = Number.isFinite(Number(value)) ? Number(value).toFixed(1) : '0.0';
  return (
    <span
      className={`pp-browse-rating${accent ? ' is-accent' : ''}`}
      style={
        appUi
          ? {
              ...appTextStyle(baseline.contentText.score),
              gap: accent ? baseline.lists.rating.wrap.gap : baseline.lists.rating.memberWrap.gap,
            }
          : undefined
      }
      aria-label={`${locale === 'en' ? 'Rating' : '평점'} ${score}`}
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        style={
          appUi
            ? { width: baseline.contentRating.starSize, height: baseline.contentRating.starSize }
            : undefined
        }
      >
        <path
          fill="#F16438"
          transform="translate(0 .955)"
          d="M12 2L14.47 8.6L21.51 8.91L15.99 13.3L17.88 20.09L12 16.2L6.12 20.09L8.01 13.3L2.49 8.91L9.53 8.6L12 2Z"
        />
      </svg>
      {score}
    </span>
  );
}
export default function BrowseReviewCard({ item, view = 'feed', first = false, last = false }) {
  const { locale } = useWebLocale();
  const title = <AlbumContentTitle item={item} title={item.albumTitle} />;
  const artist = (
    <span className="pp-browse-artist">
      {item.artist?.name || (locale === 'en' ? 'Unknown artist' : '아티스트 정보 없음')}
    </span>
  );
  const cover = (
    <span className="pp-browse-cover">
      {item.albumImageUrl && <RecoverableImage src={item.albumImageUrl} alt="" loading="lazy" />}
    </span>
  );
  const identity = (
    <AppAuthor
      name={item.userNickname || ''}
      image={item.userProfileImageUrl}
      mark={item.userProfileMark}
    />
  );
  const date = (
    <time className="pp-browse-date" dateTime={item.createdAt}>
      {item.createdAt?.slice(0, 10).replaceAll('-', '.')}
    </time>
  );
  if (view === 'albums')
    return (
      <article className="pp-browse-review-album">
        <Link to={reviewAlbumPath(item)} className="pp-browse-review-album-summary">
          {cover}
          {title}
          {artist}
          <BrowseRating value={item.rating} />
        </Link>
        <Link to={reviewPath(item)} className="pp-browse-review-album-body">
          <p
            style={appTextStyle(
              baseline.lists.reviews.albumReviewText,
              baseline.contentText.preview,
            )}
          >
            {item.content}
          </p>
          <span className="pp-browse-album-author">{identity}</span>
          {date}
        </Link>
      </article>
    );
  return (
    <Link
      to={reviewPath(item)}
      className={`pp-browse-review-feed${first ? ' is-first' : ''}${last ? ' is-last' : ''}`}
    >
      <div className="pp-browse-quote">
        <svg viewBox="0 0 14 14" aria-hidden="true">
          <path
            fill="currentColor"
            d="M0 7.1C0 3.7 1.7 1.3 5 0l.8 1.8C4 2.6 3.1 3.8 2.9 5.2h2.8V10H0V7.1Zm8.2 0c0-3.4 1.7-5.8 5-7.1l.8 1.8c-1.8.8-2.7 2-2.9 3.4H14V10H8.2V7.1Z"
          />
        </svg>
        <p style={appTextStyle(baseline.lists.reviews.reviewText, baseline.contentText.preview)}>
          {item.content}
        </p>
      </div>
      <div className="pp-browse-review-meta">
        {cover}
        <div className="pp-browse-review-copy">
          {title}
          {artist}
          <span className="pp-browse-author">
            {identity}
            <span>·</span>
            {date}
          </span>
        </div>
        <BrowseRating value={item.rating} />
      </div>
    </Link>
  );
}
